/**
 * 存取驗證 Token
 */
export const useAuthorization = () => useCookie('ug_authorization')
